<template>
<div>

  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Supplier Schedule</el-breadcrumb-item>
    <el-breadcrumb-item>PO Schedule</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col>
  </el-row>
  <!--卡片视图区域-->

  <el-card>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-row>
        <el-col :span = "8">
      <el-form-item label="Brand:" label-width="150px">
          <el-select v-model="formInline.brand" multiple collapse-tags
            style="margin-left: 0px;"
            placeholder="please choose">
          <el-option
          v-for="item in this.brandList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
          </el-form-item>
          </el-col>
          <el-col :span = "8">
      <el-form-item label="Buyer:" label-width="115px">
          <el-select v-model="formInline.buyer" multiple collapse-tags
            style="margin-left: 0px;"
            placeholder="please choose">
          <el-option
          v-for="item in this.buyerList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
          </el-form-item>
          </el-col>

        <el-col :span = "8">
          <el-form-item label="Category:">
            <el-select v-model="formInline.category" multiple collapse-tags
                  style="margin-left: 0px;"
                  placeholder="please choose">
                <el-option
                v-for="item in this.categoryList"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span = "8">
          <el-form-item label="Delivery Address:" label-width="150px">
            <el-select v-model="formInline.deliveryAddr" multiple collapse-tags
                  style="margin-left: 0px;"   filterable
                  placeholder="please choose">
                <el-option
                v-for="item in this.deliveryAddrList"
                :key="item"
                :label="item"
                :value="item">
                <!-- <span style="float: left">{{ item.description }}</span>
                <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.code }}</span> -->
              </el-option>
            </el-select>
          </el-form-item>
        <!-- <el-form-item label="Delivery Address:" label-width="150px">
          <el-select v-model="formInline.deliveryAddr" multiple collapse-tags
                style="margin-left: 0px;"
                placeholder="please choose">
              <el-option
              v-for="item in deliveryAddrArr"
              :key="item.code"
              :label="item.description"
              :value="item.code">
              <span style="float: left">{{ item.description }}</span>
              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.code }}</span>
            </el-option>
          </el-select>
        </el-form-item> -->
        </el-col>
        <el-col :span = "8">
        <el-form-item label="Supplier:" label-width="115px">
          <el-input v-model="formInline.supplier" placeholder="Supplier" clearable></el-input>
        </el-form-item>
        </el-col>
        <el-col :span = "8">
        <el-form-item>
          <el-button type="primary" @click="onSubmit">Search</el-button>
        </el-form-item>
       <el-form-item>
          <el-button type="primary" @click="exportToExcel">Excel</el-button>
        </el-form-item>
        </el-col>
        </el-row>
      </el-form>

      <div style="overflow: auto;width: 100%;">
      <table width="2000px" class="table-style" align="center" cellspacing=0 cellpadding=0>
          <tbody>
              <tr class="table-header">
                  <td colspan="3"></td>
                  <td v-for= "(item,index) in allYymmWeekCntList" :colspan="item[1]" v-bind:key="index">{{ item[0] }}</td>
                  <td>Total</td>
              </tr>
              <tr class="table-header">
              <td>Po#</td>
              <td>Item</td>
              <td>Item Name</td>
              <td v-for= "(item,index) in allWeeksNbrList" v-bind:key="index">{{ item }}</td>
              <td></td>
              </tr>

              <template v-for= "input in inputList">
                <tr v-for= "(item,index) in input.items" v-bind:key="item.id">
                  <td v-if="index===0" :rowspan="input.items.length">{{input.poNbr}}</td>
                  <td>{{item.code}}</td>
                  <td>{{item.name}}</td>
                  <td v-for= "(week,index2) in item.weeks" :key="'2-'+index2">{{ checkZero(numFormat(Math.round(week.value * 10) / 10))}}</td>
                  <td>{{ checkZero(numFormat(Math.round(item.total * 10) / 10))}}</td>
                </tr>

              <tr v-bind:key="input.poNbr">
              <td class="sub-total">{{ input.poNbr }} Total</td>
              <td class="sub-total"></td>
              <td class="sub-total"></td>
              <td class="sub-total" v-for= "(poTotal,index) in input.onePoTotal" v-bind:key="index">{{ checkZero(numFormat(Math.round(poTotal * 10) / 10)) }}</td>
              <td class="sub-total">{{checkZero(numFormat(Math.round(input.onePoSum * 10) / 10))}}</td>
              </tr>
              </template>
              <tr class="total">
                <td class="total">TOTAL</td>
                <td></td>
                <td></td>
                <td v-for= "(allPoWeekTotalItem,index) in allPoWeekTotal" v-bind:key="'1-'+index">{{ checkZero(numFormat(Math.round(allPoWeekTotalItem * 10) / 10))}}</td>
                <td class="total">{{ checkZero(numFormat(Math.round(valueTotal * 10) / 10)) }}</td>
              </tr>
              </tbody>
              </table>
              </div>

  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        category: [],
        buyer: [],
        brand: [],
        deliveryAddr: [],
        supplier: ''
        // page: 1,
        // rows: 100
      },
      userName: '',
      inputList: [],
      allYymmWeekCntList: [],
      allWeeksNbrList: [],
      allPoWeekTotal: [],
      valueTotal: '',
      brandList: '',
      deliveryAddrList: [],
      buyerList: '',
      categoryList: '',
      options: [{
        value: 'DEV',
        label: 'Development',
        description: 'Development'
      }, {
        value: 'HLD',
        label: 'On Hold',
        description: 'On Hold'
      }, {
        value: 'LHK',
        label: 'Loading Hong Kong',
        description: 'Loading Hong Kong'
      }, {
        value: 'LSH',
        label: 'Loading Shanghai',
        description: 'Loading Shanghai'
      }, {
        value: 'LXI',
        label: 'Loading Xiamen',
        description: 'Loading Xiamen'
      }, {
        value: 'LYA',
        label: 'Loading Yantian',
        description: 'Loading Yantian'
      }, {
        value: 'NEW',
        label: 'New Order',
        description: 'New Order'
      }, {
        value: 'OKC',
        label: 'Confirmed to Close on arrival',
        description: 'Confirmed to Close on arrival'
      }, {
        value: 'OLO',
        label: 'On Line QC Pass',
        description: 'On Line QC Pass'
      }, {
        value: 'ONG',
        label: 'On Going Production',
        description: 'On Going Production'
      }, {
        value: 'PND',
        label: 'Pending for Approval',
        description: 'Pending for Approval'
      }, {
        value: 'REJ',
        label: 'Reject',
        description: 'Reject'
      }, {
        value: 'RHK',
        label: 'Ready Hong Kong',
        description: 'Ready Hong Kong'
      }, {
        value: 'RSH',
        label: ' Ready Shanghai',
        description: ' Ready Shanghai'
      }, {
        value: 'RTC',
        label: 'Request to Close',
        description: 'Request to Close'
      }, {
        value: 'RXI',
        label: 'Ready Xiamen',
        description: 'Ready Xiamen'
      }, {
        value: 'RYA',
        label: 'Ready Yantian',
        description: 'Ready Yantian'
      }, {
        value: 'SFR',
        label: 'Shipment ready from France',
        description: 'Shipment ready from France'
      }, {
        value: 'SME',
        label: 'Shipment ready from Mexico',
        description: 'Shipment ready from Mexico'
      }, {
        value: 'TLB',
        label: 'Ready for Transfer to LB',
        description: 'Ready for Transfer to LB'
      }, {
        value: 'TYF',
        label: 'Ready for Transfer to Yufan',
        description: 'Ready for Transfer to Yufan'
      }, {
        value: 'WFC',
        label: 'Waiting for confirmation',
        description: 'Waiting for confirmation'
      }
      ],
      deliveryAddrArr: [{
        code: 'AD_2',
        description: 'IP Dayton'
      }, {
        code: 'AD_1',
        description: 'IP New York'
      }, {
        code: 'INT',
        description: 'IP Dayton'
      }, {
        code: 'TSM',
        description: 'TSM'
      }, {
        code: 'ENDEK',
        description: 'TSM'
      }, {
        code: 'FTZ',
        description: 'FTZ FG'
      }, {
        code: 'FTZ_1',
        description: 'FTZ COMPO'
      }, {
        code: 'LIFE',
        description: 'LB'
      }, {
        code: 'YFF',
        description: 'YF'
      }, {
        code: '3Star',
        description: '3Star'
      }, {
        code: 'CHI',
        description: 'ChiKwong'
      }, {
        code: 'EUROS',
        description: 'EUROS'
      }
      ],
      updateTime: '',
      brandParam: {
        userName: '',
        userType: ''
      }
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getBrands()
    this.getBuyers()
    this.getCategoryDeliveryAddrList()
    this.getYach1List()
    this.getDeliveryAddrList()
  },
  methods: {
    async getYach1List () {
      var brandStr = ''
      if (this.formInline.brand && this.formInline.brand.length) {
        this.formInline.brand = [...this.formInline.brand].join(',')
        brandStr = this.formInline.brand
      }

      var deliveryAddrStr = ''
      if (this.formInline.deliveryAddr && this.formInline.deliveryAddr.length) {
        this.formInline.deliveryAddr = [...this.formInline.deliveryAddr].join(',')
        deliveryAddrStr = this.formInline.deliveryAddr
      }
      var categoryStr = ''
      if (this.formInline.category && this.formInline.category.length) {
        this.formInline.category = [...this.formInline.category].join(',')
        categoryStr = this.formInline.category
      }

      var buyerStr = ''
      if (this.formInline.buyer && this.formInline.buyer.length) {
        this.formInline.buyer = [...this.formInline.buyer].join(',')
        buyerStr = this.formInline.buyer
      }
      const { data: res } = await this.$http.get('/show/inputYach', { params: this.formInline })

      this.allYymmWeekCntList = await res.allYymmWeekCntList
      this.allWeeksNbrList = await res.allWeeksNbrList
      this.allPoWeekTotal = await res.allPoWeekTotal
      this.valueTotal = await res.total
      this.inputList = await res.inputList
      this.updateTime = await res.createTime
      if (brandStr !== '') {
        await this.$set(this.formInline, 'brand', brandStr.split(','))
      }
      if (buyerStr !== '') {
        await this.$set(this.formInline, 'buyer', buyerStr.split(','))
      }
      if (deliveryAddrStr !== '') {
        await this.$set(this.formInline, 'deliveryAddr', deliveryAddrStr.split(','))
      }
      if (categoryStr !== '') {
        await this.$set(this.formInline, 'category', categoryStr.split(','))
      }
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getYach1List()
    },
    exportToExcel () {
      window.open('https://www.myirequest.com:8081/show/exportInputSchedule?supplier=' + this.formInline.supplier + '&brand=' + this.formInline.brand + '&buyer=' + this.formInline.buyer +
       '&category=' + this.formInline.category + '&deliveryAddr=' + this.formInline.deliveryAddr + '&token=' + encodeURIComponent(this.formInline.token) // + '&poDate=' + this.formInline.poDate, '_parent')
      , '_parent')
    },
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    async getBuyers () {
      const { data: res } = await this.$http.get('/common/buyerList')
      this.buyerList = await res.buyerList
    },
    async getDeliveryAddrList () {
      const { data: res } = await this.$http.get('/show/deliveryAddrList', { params: this.brandParam })
      this.deliveryAddrList = await res.deliveryAddr
    },
    async getCategoryDeliveryAddrList () {
      const { data: res } = await this.$http.get('/show/categoryDeliveryAddrList')
      this.categoryList = await res.categoryList
      // this.deliveryAddrList = await res.deliveryAddrList
    },
    numFormat (numrc) {
      if (numrc === null || numrc === '') {
        return
      }
      var result = ''
      var counter = 0

      numrc = (numrc || 0).toString()
      for (var i = numrc.length - 1; i >= 0; i--) {
        counter++
        result = numrc.charAt(i) + result
        if (!(counter % 3) && i !== 0) {
          result = ' ' + result
        }
      }
      return result
    },
    checkZero (value) {
      if (value === 0 || value === 0.0 || value === '0') {
        return ''
      }
      return value
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .table-style {
    // width: 100%;
    border: 0.1px solid #ddd;
    border-collapse: collapse;
    font-size: 12px;
    font-family:Consolas;
    line-height: 35px;
    color: #606266;
    // overflow-x: scroll;
  }
  // tbody {
  //   overflow-x: auto;
  // }
  .table-header {
    // background-color: rgb(192,192,192);
    font-weight: 500;
    line-height: 45px;
    // background-color: rgb(214,237,239);
    border: 1px solid #ddd;
  }
  td {
    border: 0.1px solid #ddd;
    // color: #8E2323;
  }
  .sub-total {
    background-color: rgb(230,230,230);
    // color: rgb(254,82,107);
  }
  .total {
    background-color: rgb(192,192,192);
    line-height: 39px;
  }

</style>
